import { FormattedMessage } from 'dibs-react-intl';
import fieldKeys from './fieldKeys';
import failureReasons from './shippingFailureReasons';
import mcLink from './mcLink';

export default {
    [fieldKeys.barHeaderTitleSent]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.shipping.header.title_sent"
            defaultMessage="Shipping Quote Requests Sent!"
        />
    ),
    [fieldKeys.barHeaderTitleFailed]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.shipping.header.title_failed"
            defaultMessage="Shipping Quote Requests Failed"
        />
    ),
    [fieldKeys.barHeaderSubtitle]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.shipping.header.subtitle"
            defaultMessage="The seller(s) will respond to your requests via {mcLink}"
            values={{ mcLink }}
        />
    ),
    [fieldKeys.successHeadline]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.shipping.listHeader.success"
            defaultMessage="Shipping quote requests successfully sent for:"
        />
    ),
    [fieldKeys.failHeadline]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.shipping.listHeader.fail"
            defaultMessage="Shipping quote requests failed to send for:"
        />
    ),
    failureReasons,
};
